import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-app-store-publishing-destinations-section',
  imports: [SectionHeaderComponent, TuiIcon],
  templateUrl: './app-store-publishing-destinations-section.component.html',
  styleUrl: './app-store-publishing-destinations-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppStorePublishingDestinationsSectionComponent {
  protected readonly destinations = [
    {
      name: 'Apple App Store',
      icon: '@tui.fa.brands.apple',
      features: [
        'Automatic TestFlight upload',
        'App Store submission',
        'App Store Connect API integration',
        'Beta testing groups management',
      ],
    },
    {
      name: 'Google Play Store',
      icon: '@tui.fa.brands.google-play',
      features: [
        'Internal testing track',
        'Alpha and Beta tracks',
        'Production releases',
        'Staged rollouts support',
      ],
    },
  ];
}
